export const dark_blue = `rgb(12,17,24)`
export const mid_blue = `rgb(88, 137, 185)`
